import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { useAuth, useLogout } from '../hooks';

export default function Logout() {
    const { auth } = useAuth()
    const logout = useLogout()
    useEffect(() => {logout()}, [])
    
    if(auth) return <Outlet/>
    return <Navigate to="/" />
}